import { useContext, useCallback } from "react";
import { azureTokenContext, userIdContext } from "../App";
import * as ApiCalls from "../components/Serving/ApiCalls";

interface LogMetricOptions {
    category: string;
    subCategory: string;
    status?: string;
    tag?: string;
    message: string;
    workItemId?: string;
    userRole?: string;
    payload?: Record<string, unknown>;
}

export function useLogMetric() {
    const azureToken = useContext(azureTokenContext);
    const userId = useContext(userIdContext);

    const logMetric = useCallback((options: LogMetricOptions) => {
        const {
            category,
            subCategory,
            status = "Success",
            tag = "",
            message,
            workItemId = "",
            userRole = "",
            payload
        } = options;

        return ApiCalls.logMetric(
            category,
            subCategory,
            status,
            tag,
            message,
            workItemId,
            userRole,
            userId,
            azureToken,
            payload
        );
    }, [userId, azureToken]);

    return logMetric;
}
